((document, window, history) => {
	const pushState = history.pushState;

	// default cookie compliance script
	function cookieCompliance() {
		if (document.querySelector('.dtaleddesigns-ui-biscuit-banner__button')) {
			document.querySelector('.dtaleddesigns-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.dtaleddesigns-ui-biscuit-banner').classList.add('dtaleddesigns-ui-biscuit-banner--hide');

				window._dtaleddesigns.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.dtaleddesigns-ui-biscuit-banner__button--close')) {
			document.querySelector('.dtaleddesigns-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.dtaleddesigns-ui-biscuit-banner').classList.add('dtaleddesigns-ui-biscuit-banner--hide');
			});
		}
	}

	// default navicon
	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active'); document.querySelector('.site-navigation').classList.toggle('site-navigation__nav--active');
			document.body.classList.toggle('site-navigation__nav--open');
		});
	}

	// default navigation subnav
	function navigation(submenu) {
		if (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0)) {
			window._dtaleddesigns.helpers.getSiblings(submenu)[ 0 ].addEventListener('click', (e) => {
				if (!e.target.classList.contains('site-navigation__menu-item--active')) {
					e.preventDefault();

					e.currentTarget.classList.add('site-navigation__menu-item--active');
					submenu.classList.add('site-navigation__sub-menu--active');

					for (let i = 0; i < window._dtaleddesigns.helpers.getSiblings(e.currentTarget.parentNode).length; i += 1) {
						if (window._dtaleddesigns.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ] && window._dtaleddesigns.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.contains('site-navigation__menu-item--active')) {
							window._dtaleddesigns.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.remove('site-navigation__menu-item--active');
						}

						if (window._dtaleddesigns.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ] && window._dtaleddesigns.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.contains('site-navigation__sub-menu--active')) {
							window._dtaleddesigns.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.remove('site-navigation__sub-menu--active');
						}
					}
				} else {
					return true;
				}
			});
		} else {
			submenu.parentNode.addEventListener('mouseover', () => {
				if (submenu.parentNode.querySelector('.site-navigation__sub-menu--active')) {
					submenu.parentNode.querySelectorAll('.site-navigation__sub-menu--active').forEach((_sel) => {
						_sel.classList.remove('site-navigation__sub-menu--active');
						_sel.parentNode.classList.remove('site-navigation__menu-item--active');
					});
				}
				submenu.classList.add('site-navigation__sub-menu--active');
				submenu.parentNode.classList.add('site-navigation__menu-item--active');
			});

			submenu.parentNode.addEventListener('mouseout', () => {
				submenu.classList.remove('site-navigation__sub-menu--active');
				submenu.parentNode.classList.remove('site-navigation__menu-item--active');
			});
		}
	}

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.dtaleddesigns-ui-biscuit-banner')) {
			cookieCompliance();
		}

		if (document.querySelector('.site-dtaleddesigns-ui-revolver')) {
			document.querySelectorAll('[dtaleddesigns-ui="carousel"]').forEach((_sel) => {
				_sel.dtaleddesignsUiRevolverCarousel();
			});
		}

		if (document.querySelector('.site-dtaleddesigns-ui-lightbox__toggle')) {
			document.querySelectorAll('.site-dtaleddesigns-ui-lightbox__toggle').forEach((_sel) => {
				new DTaledDesignsUiLightbox(_sel);
			});
		}
	});
})(document, window, history);
